// extracted by mini-css-extract-plugin
module.exports = {"xaxis-label":"Chart_xaxis-label__xpSMn","yaxis-label":"Chart_yaxis-label__2ZWbV"};